import { useState } from "react";
import { AdminChatList } from "@/components/admin/chat/AdminChatList";
import { ClientSummary } from "@/components/admin/chat/ClientSummary";
import { AdminSidebar } from "@/components/AdminSidebar";
import { DashboardHeader } from "@/components/DashboardHeader";
import { DashboardFooter } from "@/components/DashboardFooter";
import { SidebarProvider } from "@/components/ui/sidebar";

interface Client {
  id: number;
  name: string;
  email?: string;
  status?: string;
  phone?: string;
  last_contact?: string;
}

const AdminChat = () => {
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);

  return (
    <div className="min-h-screen bg-[#1A1F2C]">
      <SidebarProvider>
        <div className="flex min-h-screen w-full">
          <AdminSidebar />
          <div className="flex-1 flex flex-col min-h-screen bg-[#1A1F2C]">
            <DashboardHeader />
            <main className="flex-1 px-6 py-8 mt-16">
              <h1 className="text-3xl font-bold text-white mb-8">Chat Management</h1>
              <div className="grid grid-cols-5 gap-6 max-w-[1600px] mx-auto">
                <div className="col-span-3">
                  <AdminChatList onClientSelect={setSelectedClient} />
                </div>
                <div className="col-span-2">
                  <ClientSummary client={selectedClient} />
                </div>
              </div>
            </main>
            <DashboardFooter />
          </div>
        </div>
      </SidebarProvider>
    </div>
  );
};

export default AdminChat;